export default "__VITE_ASSET__58615a0d__"